// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.equal .row[data-v-17c1d5e4] {\n  display: flex;\n}\n.container-fluid[data-v-17c1d5e4] {\n  margin-top: 15px;\n  margin-bottom: 15px;\n}\n", ""]);
// Exports
module.exports = exports;
